<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '1%', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :show-axis-contraction="true"
                     :colors="['#5a6672', '#8ac1ff', '#33c644', '#f2d200', '#ff6c00', '#d50000']"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {widgetMixin} from '~/mixins/widgetCommonMixin'

import {createNamespacedHelpers} from 'vuex'
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetSecRiskTrend',
  mixins: [widgetMixin],
  data () {
    return {
      w: 3,
      self: this,
      title: 'widgetSecRiskTrend',
      isLock: false,
      isMove: true,
      isResize: true,
      eventBus: true,
      deviceType: [20, 21, 23],
      restData: {
        result: [],
        unit_time: ''
      },
      series: [
        {type: 'bar', name: 'N/A', stack: 'total', barWidth: '40%'},
        {type: 'bar', name: 'Very Low', stack: 'total', barWidth: '40%'},
        {type: 'bar', name: 'Low', stack: 'total', barWidth: '40%'},
        {type: 'bar', name: 'Medium', stack: 'total', barWidth: '40%'},
        {type: 'bar', name: 'High', stack: 'total', barWidth: '40%'},
        {type: 'bar', name: 'Very High', stack: 'total', barWidth: '40%'}
      ],
      widgetData: [],
      xAxisRawData: {
        type: 'time',
        data: [],
        axisLine: { onZero: true },
        axisLabel: {
          formatter: '{HH}:{mm}:{ss}  ',
          hideOverlap: true
        }
      }
    }
  },
  computed: {
    xAxis: {
      get () { return this.xAxisRawData },
      set (options) { this.xAxisRawData = options }
    },
    tooltip () {
      return {
        axisPointer: {type: 'line'},
        formatter: (params) => {
          let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
          for (let i = 0, max = params.length; i < max; i++) {
            const cnt = Math.abs(params[i].value[1])
            resFormat += `${params[i].marker}${params[i].seriesName} : <b>${this.separateByComma(cnt)}${this.restData.unit_time}</b><br>`
          }
          return resFormat
        }
      }
    }
  },
  beforeDestroy () {
    this.self = null
  },
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({ machId }) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {
        widgetType: 'threat_risk_trend'
      }

      // Progress 출력 여부
      this.showProgress(true)

      // initFlag가 True면 기존 차트 데이터 초기
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      if (this.opts.haMember) {
        contentsOptions.dataType = this.opts.haMember
      }

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (Device Filter / IP Type 또는 HA Mamber를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams) {
        if (extraParams.haMember) {
          contentsOptions.dataType = extraParams.haMember
        }
        if (extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }
      }

      const {code, result} = await this.getWidgetData(contentsOptions)

      // 테스트 코드
      // const testData = [
      //   {name: '2021-11-21 13:40:00', type: 'N/A', value: 0},
      //   {name: '2021-11-21 13:40:00', type: 'very low', value: 0},
      //   {name: '2021-11-21 13:40:00', type: 'low', value: 0},
      //   {name: '2021-11-21 13:40:00', type: 'medium', value: 0},
      //   {name: '2021-11-21 13:40:00', type: 'high', value: 0},
      //   {name: '2021-11-21 13:40:00', type: 'very high', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'N/A', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'very low', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'low', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'medium', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'high', value: 0},
      //   {name: '2021-11-21 13:50:00', type: 'very high', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'N/A', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'very low', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'low', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'medium', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'high', value: 0},
      //   {name: '2021-11-21 14:00:00', type: 'very high', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'N/A', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'very low', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'low', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'medium', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'high', value: 0},
      //   {name: '2021-11-21 14:10:00', type: 'very high', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'N/A', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'very low', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'low', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'medium', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'high', value: 0},
      //   {name: '2021-11-21 14:20:00', type: 'very high', value: 0}
      // ]
      if (code === 'ok' && result.result && _.size(result.result) > 0) {
        this.restData = result
        this.widgetData = [[], [], [], [], [], []]
        let timeVal = ''
        const seriesIndex = {'N/A': 0, 'very low': 1, low: 2, medium: 3, high: 4, 'very high': 5}

        for (const secRisk of this.restData.result) {
          const type = secRisk.type || 'N/A'
          const time = secRisk.name
          const val = secRisk.value
          if (timeVal !== time) {
            timeVal = time
          }
          const targetIdx = seriesIndex[type]
          this.widgetData[targetIdx].push([time, val])
        }
      }
      // Progress 출력 여부
      this.showProgress(false)
    }
  },
  watch: {}
}
</script>

<style scoped>
</style>
